<template>
  <div>
    <v-card class="mr-13">
      <v-toolbar dark color="primary" shaped>
        <v-toolbar-title data-background-color="letter">Listado de Pedidos</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="mr-16">
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              shaped
              single-line
              hide-details
          ></v-text-field>
        </div>
        <v-btn
            color="secondary"
            absolute
            top
            right
            fab
            @click="toogleForm"
            :disabled="showForm"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
          :headers="header"
          :items="pedidos"
          :search="search"
          :loading="loading"
          loading-text="Cargando... Espere porfavor"
          @change="loadData"
          no-data-text="No existen Pedidos registrados en el sistema."
          :item-key="pedidos.id"

      >
        <template v-slot:body="props" >
          <tbody name="slide" is="transition-group" mode="out-in" appear>
          <template >
            <tr v-for="(item, index) in props.items" :key="item.id">
              <td>{{index+1}}</td>
              <td>{{item.fecha}}</td>
              <td>{{item.hora}}</td>
              <td><v-chip :color="getChipColor(item)">{{getChipVal(item)}}</v-chip></td>
              <td>
                <TableAction :item="item" @update="toogleForm" @delaction="deleteItem"/>
              </td>
            </tr>
          </template>
          </tbody>
        </template>

      </v-data-table>
    </v-card>
    <template>
      <pedido-form v-if="showForm" :title="title" :show-form="showForm"
                   :pedido="editItem" @close="toogleForm" />
    </template>
    <template>
      <v-dialog persistent max-width="200" transition="dialog-top-transition" v-if="menuLocked" v-model="menuLocked">
        <v-card>
          <v-card-title>Eliminar</v-card-title>
          <v-card-text>Seguro que desea eliminar el pedido para el día{{itemToDelete.fecha}}
            y la hora {{itemToDelete.hora}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="terciary"
                text
                @click="deleteItemCancel"
                icon
            >
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn
                color="secondary"
                text
                @click="deleteItemConfirm"
                icon
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>
</template>

<script>
import TableAction from "../../components/TableAction";
import {mapGetters} from "vuex";
import PedidoForm from "../../components/Pedido/PedidoForm";
export default {
  name: "PedidoList",
  components: {TableAction, PedidoForm},
  data:()=>({
    loading: false,
    showForm: false,
    search: '',
    title:'',
    defaultEditItem: null,
    editItem: null,
    itemToDelete: null,
    menuLocked: false,
    deleteConfirmId: '',
    header: [
      { text: 'No', value: 'num', sortable: false },
      { text: 'Fecha', value: 'fecha' },
      { text: 'Hora', value: 'hora' },
      { text: 'Estado', value: 'estado' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
  }),
  computed: {
    ...mapGetters(['pedidos']),
  },
  mounted() {
    if(this.pedidos.length<=0){
      this.loadData()
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      await this.$store.dispatch("allPedidos");
      this.loading = false;
    },
    toogleForm(item){
      this.pedidos.indexOf(item)=== -1 ? (this.editItem= {}, this.title='Nuevo Pedido') :
          (this.editItem = {...item}, this.title='Actualizar Pedido');
      this.showForm = ! this.showForm;
    },
    getChipColor(item) {
      switch (item.estado) {
        case 1:
          return "secondary"
        case 2:
          return "blue lighten-1"
        case 3:
          return "pink lighten-1"
        case 4:
          return "success lighten-1"
        case 0:
          return "danger lighten-1"
      }
    },
      getChipVal(item) {
        switch (item.estado) {
          case 1:
            return "Pendiente"
          case 2:
            return "Aprovado"
          case 3:
            return "En Proceso"
          case 4:
            return "Terminado"
          case 0:
            return "Cancelado"
        }
    },

    deleteItem(item) {
      this.itemToDelete = item
      this.menuLocked = true

    },

    async deleteItemConfirm() {
      if (this.itemToDelete !== null) {
        await this.$store.dispatch("deletePedido", this.itemToDelete);
        this.menuLocked = false;
        this.itemToDelete = null;

      }
    },

    deleteItemCancel() {
      this.menuLocked = false
      this.itemToDelete = null
    },
  },
}
</script>

<style scoped>
.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
}
.slide-live-active {
  animation: slide-out 1s ease-out forwards;
}
@keyframes slide-in {
  from {
    transform: translateY(-30px);
  } to {
      transform: translateY(0);
    }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  } to {
      transform: translateY(-30px);
    }
}
</style>
